<template lang="html">
  <footer class="footer">
    <bim-container>
      <div class="footer-first-line">
        <div class="footer-first-line__logo" v-html="require('@/assets/img/bim-logo.svg')" />
        <div class="footer-first-line__info">
          <a href="tel:88005002575" class="footer-first-line__phone">
            <div class="footer-first-line__phone__icon" v-html="require('@/assets/img/phone-green.svg')" />
            8 800 500-25-75
          </a>
          <a href="mailto:info@bimlib.pro" class="footer-first-line__email">
            <div class="footer-first-line__phone__icon" v-html="require('@/assets/img/email-green.svg')" />
            info@bimlib.pro
          </a>
          <SocialLinks class="footer-first-line__socs" />
        </div>
        <div class="footer-first-line__up" @click="up">
          Наверх
          <div class="footer-first-line__up__icon" v-html="require('@/assets/img/up.svg')" />
        </div>
      </div>

      <div class="footer__nav">
        <div class="footer__nav__links">
          <div v-for="(group, i) in groupsLinks" :key="`group${i}`" class="footer__nav__group">
            <div class="footer__nav__group__name">{{ group.title }}</div>
            <a v-for="(link, l) in group.links" :key="`link${i}${l}`" class="footer__nav__link" v-bind="link">
              {{ link.title }}
            </a>
          </div>
        </div>

        <div class="footer__telegram">
          <div class="footer__telegram__image" v-html="require('@/assets/img/telegram-footer.svg')" />
          <div class="footer__telegram__text">
            <div class="footer__telegram__title">Подпишитесь на наш телеграм-канал</div>
            <div class="footer__telegram__desc">чтобы не пропускать новости из мира BIM</div>
            <bim-button class="footer__telegram__button" outline href="https://t.me/bimlib_pro" target="_blank">
              Подписаться
            </bim-button>
          </div>
        </div>
      </div>

      <div class="footer__companies">
        <div class="footer__logos">
          <a aria-label="Логотип Минпромторг" title="Минпромторг" href="https://minpromtorg.gov.ru/" target="_blank">
            <MinpromtorgLogo class="footer__logo" />
          </a>
          <a aria-label="Логотип ГИСП" title="ГИСП" href="https://gisp.gov.ru/mainpage/" target="_blank">
            <GispLogo class="footer__logo" />
          </a>
          <a aria-label="Логотип ГК Основа" title="ГК Основа" href="https://gk-osnova.ru/?from=bimlib.pro" target="_blank">
            <OsnovaLogo class="footer__logo" />
          </a>
          <a aria-label="Логотип Физтехпарк" title="Физтехпарк" href="https://phystechpark.ru/?from=bimlib.pro" target="_blank">
            <FistechLogo class="footer__logo" />
          </a>
          <a aria-label="Логотип НОПСМ" title="НОПСМ" href="http://natamac.ru/?from=bimlib.pro" target="_blank">
            <NopsmLogo class="footer__logo" />
          </a>
          <a aria-label="Логотип МИНЭКС" title="МИНЭКС" href="https://minexpert.ru/?from=bimlib.pro" target="_blank">
            <MineskLogo class="footer__logo" />
          </a>
        </div>

        <div class="footer__sk">
          <a aria-label="Логотип SK" title="SK" href="https://navigator.sk.ru/orn/1123273?from=bimlib.pro" target="_blank">
            <SkLogo class="footer__sk__logo" />
          </a>
          <div class="footer__sk__text">
          Система управления сайтом и модуль библиотеки разработаны ООО БИМ при поддержке Фонда Сколково
          </div>
        </div>
      </div>

      <div class="footer__last-line">
        <div class="footer__last-line__left">
          <a class="footer__last-line__link" href="/user_agreement/" target="_blank" rel="nofollow">
            Пользовательское соглашение
          </a>
          <a class="footer__last-line__link" href="/agreement/" target="_blank" rel="nofollow">
            Согласие на обработку персональных данных
          </a>
          <a class="footer__last-line__link" href="/legal/offer/itm/offer_itm.pdf" target="_blank" rel="nofollow">
            Оферта
          </a>
          <a class="footer__last-line__link" href="/recommendation/" target="_blank" rel="nofollow">
            Рекомендательные технологии
          </a>
        </div>
        <div class="footer__last-line__right">© ООО «ИТМ»</div>
      </div>
    </bim-container>
  </footer>
</template>

<script>
  import bimContainer from '@/components/grid/bimContainer/bimContainer'
  import BimButton from '@/components/form/bimButton/bimButton.vue'
  import SocialLinks from '@/components/core/social-links'

  import FistechLogo from '@/components/core/bimFooter/Fistech'
  import GispLogo from '@/components/core/bimFooter/Gisp'
  import MineskLogo from '@/components/core/bimFooter/Mineks'
  import MinpromtorgLogo from '@/components/core/bimFooter/Minpromtorg'
  import NopsmLogo from '@/components/core/bimFooter/Nopsm'
  import OsnovaLogo from '@/components/core/bimFooter/Osnova'
  import SkLogo from '@/components/core/bimFooter/Sk'

  export default {
    name: 'bimFooter',
    components: {
      BimButton,
      bimContainer,
      SocialLinks,
      FistechLogo,
      GispLogo,
      MineskLogo,
      MinpromtorgLogo,
      NopsmLogo,
      OsnovaLogo,
      SkLogo,
    },
    data: () => ({
      groupsLinks: [
        {
          title: 'Главное',
          links: [
            { title: 'BIM-модели', href: '/models/' },
            { title: 'Плагины', href: '/plugins/' },
            { title: 'Читальный зал', href: '/articles/' },
            { title: 'Производители', href: '/manufacturers/' },
          ]
        },
        {
          title: 'Каталоги',
          links: [
            { title: 'Семейства Autodesk Revit (BIM 2.0)', href: '/revit/' },
            { title: 'Каталоги Autodesk Civil 3D', href: '/civil3d/' },
            { title: 'Библиотечные элементы Archicad', href: '/archicad/' },
            { title: 'Каталоги Renga', href: '/renga/' },
            { title: 'Каталоги IFC', href: '/ifc/' },
          ]
        },
        {
          title: 'Компания',
          links: [
            { title: 'COSTX', href: 'https://costx.ru/', target: '_blank' },
            { title: 'IRMA', href: 'https://irma.pro/', target: '_blank' },
            { title: 'О компании', href: '/about/' },
          ]
        }
      ]
    }),
    methods: {
      up () {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .footer {
    padding: 30px 0;
    background-color: #fff;
    font-family: 'Helvetica Neue', sans-serif;
    @media (min-width: 576px) {
      padding: 65px 0;
    }
  }

  .footer__last-line__left {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media (max-width: 959px) {
      flex-direction: column;
      align-items: flex-start;
    }
    @media (max-width: 575px) {
      margin-bottom: 20px;
    }
  }

  .footer__last-line {
    @media (min-width: 576px) {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .footer__last-line {
    padding-top: 32px;
    &__link {
      font-weight: 400;
      font-size: 14px;
      color: rgba(37, 37, 37, 0.7);
      text-decoration: none;
      & + & {
        @media (min-width: 960px) {
          margin-left: 16px;
        }
        @media (max-width: 959px) {
          margin-top: 5px;
        }
      }
    }

    &__right {
      font-size: 14px;
      color: rgba(37, 37, 37, 0.7);
    }
  }

  .footer__companies {
    padding: 35px 0;
    border-bottom: 1px solid #EAEAEA;
    @media (min-width: 960px) {
      display: flex;
      align-items: center;
      justify-content: space-between;

    }
  }

  .footer__sk {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .footer__logos {
    display: flex;
    align-items: center;
    justify-content: center;
    @media (min-width: 576px) {
      justify-content: space-between;
    }
  }

  .footer__logos {
    @media (min-width: 960px) {
      margin-right: 20px;
    }
    @media (max-width: 1279px) {
      flex-wrap: wrap;
    }
    @media (max-width: 959px) {
      margin-bottom: 20px;
    }
  }

  .footer__logo {
    padding: 10px;
    cursor: pointer;
    opacity: .8;
    filter: grayscale(1) opacity(0.5);
    transition: all ease 0.3s;

    &:hover {
      opacity: 1;
      filter: none;
    }
  }

  .footer__sk {
    @media (max-width: 959px) {
      max-width: 400px;
    }
    &__logo {
      width: 42px;
      height: 42px;
      margin-right: 15px;
      filter: grayscale(1) opacity(0.5);
    }
    &__text {
      font-size: 12px;
      font-weight: 400;
      line-height: 140%;
      letter-spacing: 0.03em;
      color: rgba(37, 37, 37, 0.7);
    }
  }

  .footer__telegram {
    display: flex;
    width: 420px;
    box-sizing: border-box;
    @media (min-width: 960px) {
      padding: 10px 24px;
    }
    @media (max-width: 1279px) {
      width: 340px;
      padding-right: 0;
    }
    @media (max-width: 575px) {
      width: auto;
      max-width: 360px;
    }

    &__image {
      margin-right: 16px;
    }

    &__title {
      font-weight: 500;
      font-size: 16px;
      line-height: 124.99%;
      margin-bottom: 8px;
    }

    &__desc {
      font-size: 14px;
      line-height: 138.4%;
      margin-bottom: 24px;
    }

    &__button {
      text-decoration: none;
      font-weight: 500;
      font-size: 16px;
      height: auto;
      padding: 14px 16px;
    }
  }

  .footer__nav {
    margin-top: 32px;
    padding-bottom: 32px;
    border-bottom: 1px solid #EAEAEA;
    @media (min-width: 960px) {
      display: flex;
      justify-content: space-between;
    }

    &__links {
      margin-right: 30px;
      @media (max-width: 959px) {
        margin-bottom: 20px;
      }
      @media (min-width: 960px) {
        max-width: 550px;
      }
      @media (min-width: 576px) {
        display: flex;
        flex-shrink: 0;
        flex-grow: 1;
        justify-content: space-between;
      }
    }

    &__link {
      font-weight: 500;
      font-size: 14px;
      text-decoration: none;
      color: #252525;
      margin-bottom: 12px;
      letter-spacing: 0.005em;
    }

    &__group {
      display: flex;
      flex-direction: column;
      @media (max-width: 575px) {
        margin-bottom: 20px;
      }

      &__name {
        color: rgba(37, 37, 37, 0.7);
        font-weight: 500;
        font-size: 16px;
        margin-bottom: 15px;
        letter-spacing: 0.005em;
        @media (min-width: 576px) {
          margin-bottom: 32px;
        }
      }
    }
  }

  .footer-first-line {
    padding-bottom: 10px;
    border-bottom: 1px solid #EAEAEA;
    @media (min-width: 576px) {
      display: flex;
      align-items: center;
      padding-bottom: 35px;
      justify-content: space-between;
    }

    &__logo {
      width: 109px;
      @media (max-width: 767px) {
        display: none;
      }
    }

    &__info {
      @media (min-width: 576px) {
        display: flex;
        align-items: center;
      }
    }

    &__socs, &__phone, &__email, &__up {
      display: flex;
      align-items: center;
      @media (max-width: 575px) {
        margin-bottom: 15px;
      }
    }

    &__phone, &__email, &__up {
      margin-right: 25px;
      color: #00AFA1;
      font-weight: 500;
      font-size: 16px;
      text-decoration: none;
      &__icon {
        margin-right: 7px;
      }
    }

    &__up {
      cursor: pointer;
      margin-right: 0;
      @media (max-width: 575px) {
        display: none;
      }
      &__icon {
        margin-right: 0;
        margin-left: 7px;
      }
    }
  }
</style>
